// import React, { useEffect, useState } from "react";
// import { Col, Row, Card, Badge, Breadcrumb } from 'react-bootstrap';
// import { Button } from 'primereact/button';
// import { DateRangePicker } from "react-bootstrap-daterangepicker";
// import { LuView } from "react-icons/lu";
// import { FaCheck } from "react-icons/fa6";
// import axios from 'axios';
// import moment from "moment";
// import config from '../../config';
// import { useAuth } from '../../context/AuthContext';
// import '../../assets/css/notification.css';
// import { useNavigate } from "react-router-dom";

// const Notification = () => {
//     const { accessToken, userId } = useAuth();
//     const navigate = useNavigate();
//     const [notifications, setNotifications] = useState([]);
//     const [unreadCount, setUnreadCount] = useState(0);
//     const [dateRange, setDateRange] = useState({
//         startDate: moment().startOf("day"),
//         endDate: moment().endOf("day"),
//     });
//     const [loading, setLoading] = useState(false);
//     const [typeFilter, setTypeFilter] = useState('all');
//     const [priorityFilter, setPriorityFilter] = useState('all');
//     const [selectedIds, setSelectedIds] = useState([]);

//     const NOTIFICATION_FILTERS = [
//         { id: 'all', label: 'All' },
//         { id: 'review', label: 'Review' },
//         { id: 'assignment', label: 'Assignment' },
//         { id: 'due', label: 'Due / Overdue' },
//         { id: 'dept_head', label: 'Dept Head' },
//     ];

//     const PRIORITY_FILTERS = [
//         { id: 'all', label: 'All priorities' },
//         { id: 'Urgent', label: 'Urgent' },
//         { id: 'Normal', label: 'Normal' },
//         { id: 'FYI', label: 'FYI' },
//     ];

//     const priorityBadgeClass = (tag) => {
//         switch (tag) {
//             case 'Urgent':
//                 return 'bg-danger';
//             case 'FYI':
//                 return 'bg-secondary';
//             default:
//                 return 'bg-primary';
//         }
//     };

//     const matchesTypeFilter = (notification) => {
//         const type = (notification.notification_type || '').toLowerCase();
//         if (typeFilter === 'all') return true;
//         if (typeFilter === 'review') return type.includes('review');
//         if (typeFilter === 'assignment') {
//             return type.includes('assign') || type.includes('assigned');
//         }
//         if (typeFilter === 'due') {
//             return type.includes('due') || type.includes('overdue');
//         }
//         if (typeFilter === 'dept_head') {
//             return type.includes('dept head');
//         }
//         return true;
//     };

//     const matchesPriorityFilter = (notification) => {
//         if (priorityFilter === 'all') return true;
//         return (notification.priority_tag || 'Normal') === priorityFilter;
//     };

//     const visibleNotifications = notifications.filter(
//         (n) => matchesTypeFilter(n) && matchesPriorityFilter(n)
//     );

//     const toggleSelected = (notificationId) => {
//         setSelectedIds((prev) =>
//             prev.includes(notificationId)
//                 ? prev.filter((id) => id !== notificationId)
//                 : [...prev, notificationId]
//         );
//     };

//     const bulkMarkRead = async () => {
//         if (!selectedIds.length) return;
//         try {
//             await axios.put(
//                 `${config.apiBASEURL}/notificationRoutes/notifications/bulk/mark-read`,
//                 { user_id: userId, notification_ids: selectedIds },
//                 { headers: { Authorization: `Bearer ${accessToken}` } }
//             );
//             setSelectedIds([]);
//             fetchNotifications();
//         } catch (error) {
//             console.error('Bulk mark read failed:', error);
//         }
//     };

//     const bulkDelete = async () => {
//         if (!selectedIds.length) return;
//         try {
//             await axios.delete(`${config.apiBASEURL}/notificationRoutes/notifications/bulk`, {
//                 headers: { Authorization: `Bearer ${accessToken}` },
//                 data: { user_id: userId, notification_ids: selectedIds },
//             });
//             setSelectedIds([]);
//             fetchNotifications();
//         } catch (error) {
//             console.error('Bulk delete failed:', error);
//         }
//     };

//     const fetchNotifications = async () => {
//         setLoading(true);
//         try {
//             const { startDate, endDate } = dateRange;
//             const response = await axios.get(`${config.apiBASEURL}/notificationRoutes/notifications/${userId}`, {
//                 headers: {
//                     Authorization: `Bearer ${accessToken}`,
//                 },
//                 params: {
//                     start: startDate.toISOString(),
//                     end: endDate.toISOString(),
//                     priority_tag: priorityFilter !== 'all' ? priorityFilter : undefined,
//                 },
//             });
//             setNotifications(response.data.notifications);
//             setUnreadCount(response.data.unreadCount);
//         } catch (error) {
//             console.error("Error fetching notifications:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const markAsRead = async (notificationId) => {
//         try {
//             const response = await axios.put(
//                 `${config.apiBASEURL}/notificationRoutes/notifications/${notificationId}/mark-as-read`,
//                 {},
//                 {
//                     headers: {
//                         Authorization: `Bearer ${accessToken}`,
//                     },
//                 }
//             );

//             if (response.status === 200) {
//                 fetchNotifications();
//             }
//         } catch (error) {
//             console.error("Error marking notification as read:", error);
//         }
//     };

//     const openNotification = async (notification) => {
//         const link = notification.link_url?.trim();
//         if (link && link !== 'NA' && link.startsWith('/')) {
//             if (!notification.is_read) {
//                 await markAsRead(notification.notification_id);
//             }
//             navigate(link);
//             return;
//         }
//         // External links (e.g. invoice download files) open in a new tab
//         if (link && /^https?:\/\//i.test(link)) {
//             window.open(link, '_blank', 'noopener,noreferrer');
//         }
//         if (!notification.is_read) {
//             await markAsRead(notification.notification_id);
//         }
//     };


//     const handleDateRangeChange = (start, end) => {
//         setDateRange({
//             startDate: start.startOf("day"),
//             endDate: end.endOf("day"),
//         });
//     };

//     useEffect(() => {
//         fetchNotifications();
//     }, [dateRange, priorityFilter]);

//     return (
//         <>
//             <Row className="body_content">
//                 <Row className="mx-0">
//                     <Col md={6} lg={6} className="mb-4">
//                         <Breadcrumb>
//                             <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
//                                 <i className="pi pi-angle-left"></i> Back
//                             </Breadcrumb.Item>
//                             <Breadcrumb.Item active>
//                                 Notification <Badge className="bg-danger ms-2">{unreadCount}</Badge>
//                             </Breadcrumb.Item>
//                         </Breadcrumb>
//                     </Col>
//                     <Col lg={6} className="mb-4 d-flex justify-content-end align-items-center gap-2">
//                         {unreadCount > 0 && (
//                             <Button
//                                 label="Mark all read"
//                                 icon="pi pi-check"
//                                 severity="secondary"
//                                 className="border-0 py-2"
//                                 onClick={async () => {
//                                     try {
//                                         await axios.put(
//                                             `${config.apiBASEURL}/notificationRoutes/notifications/user/${userId}/mark-all-read`,
//                                             {},
//                                             { headers: { Authorization: `Bearer ${accessToken}` } }
//                                         );
//                                         fetchNotifications();
//                                     } catch (error) {
//                                         console.error('Error marking all as read:', error);
//                                     }
//                                 }}
//                             />
//                         )}
//                         <DateRangePicker
//                             initialSettings={{
//                                 startDate: dateRange.startDate.toDate(),
//                                 endDate: dateRange.endDate.toDate(),
//                                 locale: { format: "DD/MM/YYYY" },
//                                 ranges: {
//                                     Today: [moment(), moment()],
//                                     Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
//                                     "Last 7 Days": [moment().subtract(6, "days"), moment()],
//                                     "Last 30 Days": [moment().subtract(29, "days"), moment()],
//                                     "This Month": [moment().startOf("month"), moment().endOf("month")],
//                                     "Last Month": [
//                                         moment().subtract(1, "month").startOf("month"),
//                                         moment().subtract(1, "month").endOf("month"),
//                                     ],
//                                 },
//                             }}
//                             onCallback={(start, end) => handleDateRangeChange(moment(start), moment(end))}
//                         >
//                             <input
//                                 type="text"
//                                 className="form-control mx-2"
//                                 style={{ width: "200px" }}
//                                 placeholder="Select Date Range"
//                                 value={`${dateRange.startDate.format("DD/MM/YYYY")} - ${dateRange.endDate.format("DD/MM/YYYY")}`}
//                                 readOnly
//                             />
//                         </DateRangePicker>
//                     </Col>
//                     <Col lg={12} className="mb-3">
//                         <div className="d-flex flex-wrap gap-2">
//                             {NOTIFICATION_FILTERS.map((filter) => (
//                                 <Button
//                                     key={filter.id}
//                                     label={filter.label}
//                                     severity={typeFilter === filter.id ? 'info' : 'secondary'}
//                                     className="border-0 py-1 px-3"
//                                     onClick={() => setTypeFilter(filter.id)}
//                                 />
//                             ))}
//                         </div>
//                         <div className="d-flex flex-wrap gap-2 mt-2">
//                             {PRIORITY_FILTERS.map((filter) => (
//                                 <Button
//                                     key={filter.id}
//                                     label={filter.label}
//                                     severity={priorityFilter === filter.id ? 'warning' : 'secondary'}
//                                     className="border-0 py-1 px-3"
//                                     onClick={() => setPriorityFilter(filter.id)}
//                                 />
//                             ))}
//                         </div>
//                         {selectedIds.length > 0 && (
//                             <div className="d-flex flex-wrap gap-2 mt-2">
//                                 <Button
//                                     label={`Mark ${selectedIds.length} read`}
//                                     icon="pi pi-check"
//                                     severity="success"
//                                     className="border-0 py-1 px-3"
//                                     onClick={bulkMarkRead}
//                                 />
//                                 <Button
//                                     label="Delete selected"
//                                     icon="pi pi-trash"
//                                     severity="danger"
//                                     className="border-0 py-1 px-3"
//                                     onClick={bulkDelete}
//                                 />
//                             </div>
//                         )}
//                     </Col>
//                     <Col lg={12}>
//                         <Card>
//                             <Card.Body>
//                                 <ul className="notification_list">
//                                     {loading ? (
//                                         <p>Loading notifications...</p>
//                                     ) : (
//                                         visibleNotifications.length === 0 ? (
//                                             <p className="text-muted small mb-0">
//                                                 {notifications.length === 0
//                                                     ? 'No notifications for this date range.'
//                                                     : 'No notifications match this filter.'}
//                                             </p>
//                                         ) : visibleNotifications.map((notification) => (
//                                             <li
//                                                 key={notification.notification_id}
//                                                 className={notification.is_read ? "" : "active"}
//                                                 style={{
//                                                     cursor: notification.link_url && notification.link_url !== 'NA'
//                                                         ? 'pointer'
//                                                         : 'default',
//                                                 }}
//                                                 onClick={() => openNotification(notification)}
//                                                 onKeyDown={(e) => {
//                                                     if (e.key === 'Enter' || e.key === ' ') {
//                                                         e.preventDefault();
//                                                         openNotification(notification);
//                                                     }
//                                                 }}
//                                                 role={notification.link_url && notification.link_url !== 'NA' ? 'button' : undefined}
//                                                 tabIndex={notification.link_url && notification.link_url !== 'NA' ? 0 : undefined}
//                                             >
//                                                 <div className="me-2">
//                                                     <input
//                                                         type="checkbox"
//                                                         checked={selectedIds.includes(notification.notification_id)}
//                                                         onChange={(e) => {
//                                                             e.stopPropagation();
//                                                             toggleSelected(notification.notification_id);
//                                                         }}
//                                                         onClick={(e) => e.stopPropagation()}
//                                                         aria-label="Select notification"
//                                                     />
//                                                 </div>
//                                                 <div
//                                                     className={`readDiv ${notification.is_read ? "text-success" : "unreaded"}`}
//                                                 >
//                                                     {notification.is_read ? <FaCheck /> : <LuView />}
//                                                 </div>
//                                                 <div>
//                                                     <Badge className={`${priorityBadgeClass(notification.priority_tag)} me-1`}>
//                                                         {notification.priority_tag || 'Normal'}
//                                                     </Badge>
//                                                     <Badge className="bg-secondary me-1">
//                                                         {notification.notification_type}
//                                                     </Badge>
//                                                     {!notification.is_read && (
//                                                         <Badge bg="success" className="me-1">
//                                                             Unread
//                                                         </Badge>
//                                                     )}
//                                                     <h6>{notification.message}</h6>
//                                                     <p>{notification.description}</p>
//                                                     <p>
//                                                         <small>
//                                                             <i className="pi pi-clock"></i>{" "}
//                                                             {new Intl.DateTimeFormat('en-GB', {
//                                                                 day: '2-digit',
//                                                                 month: 'short',
//                                                                 year: 'numeric',
//                                                                 hour: 'numeric',
//                                                                 minute: '2-digit',

//                                                                 hour12: true,
//                                                             }).format(new Date(notification.created_at))}
//                                                         </small>
//                                                     </p>

//                                                     {!notification.is_read && (
//                                                         <Button
//                                                             title="Mark as Read"
//                                                             icon="pi pi-check"
//                                                             severity="info"
//                                                             className="p-0 view-btn2"
//                                                             onClick={(e) => {
//                                                                 e.stopPropagation();
//                                                                 markAsRead(notification.notification_id);
//                                                             }}
//                                                         />
//                                                     )}

//                                                 </div>
//                                             </li>
//                                         ))
//                                     )}
//                                 </ul>
//                             </Card.Body>
//                         </Card>
//                     </Col>
//                 </Row>
//             </Row>
//         </>
//     );
// };

// export default Notification;


import React, { useEffect, useState } from "react";
import { Col, Row, Card, Breadcrumb } from 'react-bootstrap';
import { Button } from 'primereact/button';
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import { LuView } from "react-icons/lu";
import { FaCheck } from "react-icons/fa6";
import axios from 'axios';
import moment from "moment";
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import '../../assets/css/notification.css';
import { useNavigate } from "react-router-dom";

const Notification = () => {
    const { accessToken, userId } = useAuth();
    const navigate = useNavigate();
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [dateRange, setDateRange] = useState({
        startDate: moment().startOf("day"),
        endDate: moment().endOf("day"),
    });
    const [loading, setLoading] = useState(false);
    const [typeFilter, setTypeFilter] = useState('all');
    const [priorityFilter, setPriorityFilter] = useState('all');
    const [selectedIds, setSelectedIds] = useState([]);

    const NOTIFICATION_FILTERS = [
        { id: 'all', label: 'All' },
        { id: 'review', label: 'Review' },
        { id: 'assignment', label: 'Assignment' },
        { id: 'due', label: 'Due / Overdue' },
        { id: 'dept_head', label: 'Dept Head' },
    ];

    const PRIORITY_FILTERS = [
        { id: 'all', label: 'All priorities' },
        { id: 'Urgent', label: 'Urgent' },
        { id: 'Normal', label: 'Normal' },
        { id: 'FYI', label: 'FYI' },
    ];

    const priorityBadgeClass = (tag) => {
        switch (tag) {
            case 'Urgent':
                return 'nf-tag nf-tag--urgent';
            case 'FYI':
                return 'nf-tag nf-tag--fyi';
            default:
                return 'nf-tag nf-tag--normal';
        }
    };

    const typeIconClass = (type = '') => {
        const t = (type || '').toLowerCase();
        if (t.includes('review')) return 'pi pi-eye';
        if (t.includes('assign')) return 'pi pi-user-plus';
        if (t.includes('overdue')) return 'pi pi-exclamation-triangle';
        if (t.includes('due')) return 'pi pi-clock';
        if (t.includes('dept head')) return 'pi pi-users';
        if (t.includes('invoice') || t.includes('file')) return 'pi pi-file';
        return 'pi pi-bell';
    };

    const matchesTypeFilter = (notification, filterId = typeFilter) => {
        const type = (notification.notification_type || '').toLowerCase();
        if (filterId === 'all') return true;
        if (filterId === 'review') return type.includes('review');
        if (filterId === 'assignment') {
            return type.includes('assign') || type.includes('assigned');
        }
        if (filterId === 'due') {
            return type.includes('due') || type.includes('overdue');
        }
        if (filterId === 'dept_head') {
            return type.includes('dept head');
        }
        return true;
    };

    const matchesPriorityFilter = (notification, filterId = priorityFilter) => {
        if (filterId === 'all') return true;
        return (notification.priority_tag || 'Normal') === filterId;
    };

    const visibleNotifications = notifications.filter(
        (n) => matchesTypeFilter(n) && matchesPriorityFilter(n)
    );

    const countForType = (filterId) =>
        notifications.filter((n) => matchesTypeFilter(n, filterId) && matchesPriorityFilter(n)).length;

    const countForPriority = (filterId) =>
        notifications.filter((n) => matchesTypeFilter(n) && matchesPriorityFilter(n, filterId)).length;

    const toggleSelected = (notificationId) => {
        setSelectedIds((prev) =>
            prev.includes(notificationId)
                ? prev.filter((id) => id !== notificationId)
                : [...prev, notificationId]
        );
    };

    const allVisibleSelected =
        visibleNotifications.length > 0 &&
        visibleNotifications.every((n) => selectedIds.includes(n.notification_id));

    const toggleSelectAll = () => {
        if (allVisibleSelected) {
            setSelectedIds([]);
        } else {
            setSelectedIds(visibleNotifications.map((n) => n.notification_id));
        }
    };

    const bulkMarkRead = async () => {
        if (!selectedIds.length) return;
        try {
            await axios.put(
                `${config.apiBASEURL}/notificationRoutes/notifications/bulk/mark-read`,
                { user_id: userId, notification_ids: selectedIds },
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );
            setSelectedIds([]);
            fetchNotifications();
        } catch (error) {
            console.error('Bulk mark read failed:', error);
        }
    };

    const bulkDelete = async () => {
        if (!selectedIds.length) return;
        try {
            await axios.delete(`${config.apiBASEURL}/notificationRoutes/notifications/bulk`, {
                headers: { Authorization: `Bearer ${accessToken}` },
                data: { user_id: userId, notification_ids: selectedIds },
            });
            setSelectedIds([]);
            fetchNotifications();
        } catch (error) {
            console.error('Bulk delete failed:', error);
        }
    };

    const fetchNotifications = async () => {
        setLoading(true);
        try {
            const { startDate, endDate } = dateRange;
            const response = await axios.get(`${config.apiBASEURL}/notificationRoutes/notifications/${userId}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    start: startDate.toISOString(),
                    end: endDate.toISOString(),
                    priority_tag: priorityFilter !== 'all' ? priorityFilter : undefined,
                },
            });
            setNotifications(response.data.notifications);
            setUnreadCount(response.data.unreadCount);
        } catch (error) {
            console.error("Error fetching notifications:", error);
        } finally {
            setLoading(false);
        }
    };

    const markAllRead = async () => {
        try {
            await axios.put(
                `${config.apiBASEURL}/notificationRoutes/notifications/user/${userId}/mark-all-read`,
                {},
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );
            fetchNotifications();
        } catch (error) {
            console.error('Error marking all as read:', error);
        }
    };

    const markAsRead = async (notificationId) => {
        try {
            const response = await axios.put(
                `${config.apiBASEURL}/notificationRoutes/notifications/${notificationId}/mark-as-read`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.status === 200) {
                fetchNotifications();
            }
        } catch (error) {
            console.error("Error marking notification as read:", error);
        }
    };

    const openNotification = async (notification) => {
        const link = notification.link_url?.trim();
        if (link && link !== 'NA' && link.startsWith('/')) {
            if (!notification.is_read) {
                await markAsRead(notification.notification_id);
            }
            navigate(link);
            return;
        }
        // External links (e.g. invoice download files) open in a new tab
        if (link && /^https?:\/\//i.test(link)) {
            window.open(link, '_blank', 'noopener,noreferrer');
        }
        if (!notification.is_read) {
            await markAsRead(notification.notification_id);
        }
    };

    const handleDateRangeChange = (start, end) => {
        setDateRange({
            startDate: start.startOf("day"),
            endDate: end.endOf("day"),
        });
    };

    useEffect(() => {
        fetchNotifications();
    }, [dateRange, priorityFilter]);

    return (
        <>
            <Row className="body_content nf-page">
                <Row className="mx-0">
                    <Col lg={12}>
                        <div className="nf-head">
                            <div className="nf-head__title">
                                <Breadcrumb className="nf-crumb">
                                    <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                                        <i className="pi pi-angle-left"></i> Back
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item active>Notifications</Breadcrumb.Item>
                                </Breadcrumb>
                                <h4 className="nf-title">
                                    Notifications
                                    <span className={`nf-count ${unreadCount > 0 ? 'is-active' : ''}`}>
                                        {unreadCount} unread
                                    </span>
                                </h4>
                            </div>

                            <div className="nf-head__actions">
                                {/* {unreadCount > 0 && (
                                    <Button
                                        label="Mark all read"
                                        icon="pi pi-check"
                                        className="nf-btn nf-btn--ghost"
                                        onClick={markAllRead}
                                    />
                                )} */}
                                <DateRangePicker
                                    initialSettings={{
                                        startDate: dateRange.startDate.toDate(),
                                        endDate: dateRange.endDate.toDate(),
                                        locale: { format: "DD/MM/YYYY" },
                                        ranges: {
                                            Today: [moment(), moment()],
                                            Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                                            "Last 7 Days": [moment().subtract(6, "days"), moment()],
                                            "Last 30 Days": [moment().subtract(29, "days"), moment()],
                                            "This Month": [moment().startOf("month"), moment().endOf("month")],
                                            "Last Month": [
                                                moment().subtract(1, "month").startOf("month"),
                                                moment().subtract(1, "month").endOf("month"),
                                            ],
                                        },
                                    }}
                                    onCallback={(start, end) => handleDateRangeChange(moment(start), moment(end))}
                                >
                                    <div className="nf-date">
                                        <i className="pi pi-calendar"></i>
                                        <input
                                            type="text"
                                            className="nf-date__input"
                                            placeholder="Select Date Range"
                                            value={`${dateRange.startDate.format("DD/MM/YYYY")} - ${dateRange.endDate.format("DD/MM/YYYY")}`}
                                            readOnly
                                        />
                                    </div>
                                </DateRangePicker>
                            </div>
                        </div>
                    </Col>

                    <Col lg={12}>
                        <div className="nf-filters">
                            <div className="nf-filters__row">
                                {NOTIFICATION_FILTERS.map((filter) => (
                                    <button
                                        key={filter.id}
                                        type="button"
                                        className={`nf-chip ${typeFilter === filter.id ? 'is-active' : ''}`}
                                        onClick={() => setTypeFilter(filter.id)}
                                    >
                                        {filter.label}
                                        <span className="nf-chip__count">{countForType(filter.id)}</span>
                                    </button>
                                ))}
                            </div>
                            <div className="nf-filters__row nf-filters__row--sub">
                                {PRIORITY_FILTERS.map((filter) => (
                                    <button
                                        key={filter.id}
                                        type="button"
                                        className={`nf-chip nf-chip--soft ${priorityFilter === filter.id ? 'is-active' : ''}`}
                                        onClick={() => setPriorityFilter(filter.id)}
                                    >
                                        {filter.id !== 'all' && (
                                            <span className={`nf-dot nf-dot--${filter.id.toLowerCase()}`} />
                                        )}
                                        {filter.label}
                                        <span className="nf-chip__count">{countForPriority(filter.id)}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </Col>

                    <Col lg={12}>
                        <Card className="nf-card">
                            <Card.Body className="p-0">
                                <div className="nf-listhead">
                                    <label className="nf-check">
                                        <input
                                            type="checkbox"
                                            checked={allVisibleSelected}
                                            onChange={toggleSelectAll}
                                            disabled={visibleNotifications.length === 0}
                                            aria-label="Select all notifications"
                                        />
                                        <span>Select all</span>
                                    </label>

                                    <span className="nf-listhead__meta">
                                        {visibleNotifications.length} of {notifications.length} shown
                                    </span>

                                    {selectedIds.length > 0 && (
                                        <div className="nf-bulk">
                                            <span className="nf-bulk__label">{selectedIds.length} selected</span>
                                            <Button
                                                label="Mark read"
                                                icon="pi pi-check"
                                                className="nf-btn nf-btn--solid"
                                                onClick={bulkMarkRead}
                                            />
                                            <Button
                                                label="Delete"
                                                icon="pi pi-trash"
                                                className="nf-btn nf-btn--danger"
                                                onClick={bulkDelete}
                                            />
                                        </div>
                                    )}
                                </div>

                                <ul className="notification_list nf-list">
                                    {loading ? (
                                        <>
                                            {[0, 1, 2].map((i) => (
                                                <li key={i} className="nf-item nf-item--skeleton">
                                                    <span className="nf-sk nf-sk--avatar" />
                                                    <div className="nf-sk__lines">
                                                        <span className="nf-sk nf-sk--line" />
                                                        <span className="nf-sk nf-sk--line short" />
                                                    </div>
                                                </li>
                                            ))}
                                        </>
                                    ) : visibleNotifications.length === 0 ? (
                                        <li className="nf-empty">
                                            <i className="pi pi-inbox"></i>
                                            <p className="nf-empty__title">
                                                {notifications.length === 0
                                                    ? 'Nothing here yet'
                                                    : 'No matches for this filter'}
                                            </p>
                                            <p className="nf-empty__text">
                                                {notifications.length === 0
                                                    ? 'Pick a wider date range to see older notifications.'
                                                    : 'Try another type or priority to see more.'}
                                            </p>
                                        </li>
                                    ) : (
                                        visibleNotifications.map((notification) => {
                                            const clickable =
                                                notification.link_url && notification.link_url !== 'NA';
                                            return (
                                                <li
                                                    key={notification.notification_id}
                                                    className={`nf-item ${notification.is_read ? "" : "active is-unread"} ${selectedIds.includes(notification.notification_id) ? 'is-selected' : ''}`}
                                                    style={{ cursor: clickable ? 'pointer' : 'default' }}
                                                    onClick={() => openNotification(notification)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            e.preventDefault();
                                                            openNotification(notification);
                                                        }
                                                    }}
                                                    role={clickable ? 'button' : undefined}
                                                    tabIndex={clickable ? 0 : undefined}
                                                >
                                                    <div className="nf-item__select">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedIds.includes(notification.notification_id)}
                                                            onChange={(e) => {
                                                                e.stopPropagation();
                                                                toggleSelected(notification.notification_id);
                                                            }}
                                                            onClick={(e) => e.stopPropagation()}
                                                            aria-label="Select notification"
                                                        />
                                                    </div>

                                                    <div
                                                        className={`readDiv nf-avatar ${notification.is_read ? 'is-read' : 'unreaded'}`}
                                                    >
                                                        <i className={typeIconClass(notification.notification_type)} />
                                                    </div>

                                                    <div className="nf-item__body">
                                                        <div className="nf-item__tags">
                                                            <span className={priorityBadgeClass(notification.priority_tag)}>
                                                                {notification.priority_tag || 'Normal'}
                                                            </span>
                                                            <span className="nf-tag nf-tag--type">
                                                                {notification.notification_type}
                                                            </span>
                                                            {!notification.is_read && (
                                                                <span className="nf-tag nf-tag--unread">Unread</span>
                                                            )}
                                                        </div>

                                                        <h6 className="nf-item__title">{notification.message}</h6>
                                                        {notification.description && (
                                                            <p className="nf-item__desc">{notification.description}</p>
                                                        )}

                                                        <p className="nf-item__time">
                                                            <i className="pi pi-clock"></i>
                                                            <span>
                                                                {new Intl.DateTimeFormat('en-GB', {
                                                                    day: '2-digit',
                                                                    month: 'short',
                                                                    year: 'numeric',
                                                                    hour: 'numeric',
                                                                    minute: '2-digit',
                                                                    hour12: true,
                                                                }).format(new Date(notification.created_at))}
                                                            </span>
                                                            <span className="nf-item__ago">
                                                                {moment(notification.created_at).fromNow()}
                                                            </span>
                                                        </p>
                                                    </div>

                                                    <div className="nf-item__side">
                                                        <span
                                                            className={`nf-status ${notification.is_read ? 'is-read' : 'is-unread'}`}
                                                            title={notification.is_read ? 'Read' : 'Unread'}
                                                        >
                                                            {notification.is_read ? <FaCheck /> : <LuView />}
                                                        </span>

                                                        {!notification.is_read && (
                                                            <Button
                                                                title="Mark as read"
                                                                icon="pi pi-check"
                                                                className="nf-btn nf-btn--icon view-btn2"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    markAsRead(notification.notification_id);
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                </li>
                                            );
                                        })
                                    )}
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Row>
        </>
    );
};

export default Notification;
